import React from "react";
import { Grid, TextField, Checkbox, FormControlLabel } from "@mui/material";

const LaborAndPackagingSection = ({ form, updateField }) => {
  return (
    <>
      <Grid item xs={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.includeLabor}
              onChange={(e) => updateField("includeLabor", e.target.checked)}
            />
          }
          label="Include Labor"
        />

        {form.includeLabor && (
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextField
                type="number"
                label="Minutes"
                fullWidth
                value={form.laborMinutes}
                onChange={(e) => updateField("laborMinutes", e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                type="number"
                label="Rate (per hour)"
                fullWidth
                value={form.laborRate}
                onChange={(e) => updateField("laborRate", e.target.value)}
              />
            </Grid>
          </Grid>
        )}
      </Grid>

      <Grid item xs={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.includePackaging}
              onChange={(e) =>
                updateField("includePackaging", e.target.checked)
              }
            />
          }
          label="Include Packaging"
        />
        {/* Future packaging UI here */}
      </Grid>
    </>
  );
};

export default LaborAndPackagingSection;
